import { render, staticRenderFns } from "./couponTag.vue?vue&type=template&id=30e69d97&scoped=true"
import script from "./couponTag.vue?vue&type=script&lang=js"
export * from "./couponTag.vue?vue&type=script&lang=js"
import style0 from "./couponTag.vue?vue&type=style&index=0&id=30e69d97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e69d97",
  null
  
)

export default component.exports